import tools from '@/api/assistant/tools'
import { buildWorkflowAssistantPrompt, buildFunctionCallResponsePrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamTextResponse } from '@/ai/api'

export const generateWorkflowAssistant = async ({
  workflow,
  messagesHistory = [],
  prompt,
  abortController,
  currentUIState
}) => {
  if (!workflow) {
    return null
  }

  const messages = buildWorkflowAssistantPrompt({
    workflow,
    messagesHistory,
    prompt,
    currentUIState
  })

  try {
    const response = await fetchJsonResponse({
      messages,
      useCase: 'assistant',
      aiVersion: workflow.aiVersion || 5,
      tools,
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    // If the user cancels, treat it as a normal no-op.
    if (abortController?.signal?.aborted || error?.name === 'AbortError') {
      return null
    }

    return {
      error: {
        name: error?.name || 'Error',
        message: error?.message || 'Failed to generate AI response'
      }
    }
  }
}

export const generateFunctionCallResponse = async ({
  workflow,
  prompt,
  updatesSummary = [],
  onDelta,
  abortController
}) => {
  if (!workflow || !updatesSummary.length) {
    return null
  }

  const messages = buildFunctionCallResponsePrompt({
    prompt,
    updatesSummary
  })

  let fullText = ''
  try {
    await streamTextResponse({
      messages,
      useCase: 'assistant',
      aiVersion: workflow.aiVersion || 5,
      tools: [],
      signal: abortController?.signal,
      onChunkReceived: (chunk) => {
        fullText += chunk

        if (typeof onDelta === 'function') {
          onDelta(fullText)
        }
      }
    })

    return fullText || null
  } catch (error) {
    console.error('Error generating function call response:', error)
    return null
  }
}
